import { setOrganizationId } from '@carboncopyco/data';
import {
  TourPreviewPage,
  clearTourEditorState,
  hasInitialTourEditorState,
  setInitialTourEditorState,
  useTourSelector,
} from '@carboncopyco/mimesis-sdk';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import { settings } from '../../../settings';
import { AppEventsEnum } from '../../shared/enums/AppEventsEnum';
import useElectronListener from '../hooks/useElectronListener';
import useGetMimesisStepEngineUrl from '../hooks/useGetMimesisStepEngineUrl';
import { RumRouteTracker } from '../shared/RumRouteTracker';

const UUID = 'TOUR_ID';

type ToursArgsFromProcess = {
  organizationId: number;
  workspaceId: number;
  tourId: number;
  innerTabId: number;
};

const TourView = () => {
  const dispatch = useDispatch();
  const mimesisStepEngineRelativeUrl = useGetMimesisStepEngineUrl();
  const [argsFromProcess, setArgsFromProcess] =
    useState<ToursArgsFromProcess>();

  useEffect(() => {
    const args =
      window.dsDesktop.tour.getArgsFromProcess<ToursArgsFromProcess>();
    setArgsFromProcess(args);
  }, []);

  const organizationId = argsFromProcess?.organizationId;
  const workspaceId = argsFromProcess?.workspaceId;
  const tourId = argsFromProcess?.tourId;

  const initialRoute = `/presentation/${organizationId}/${workspaceId}/${tourId}`;

  const isStateInitialised = useTourSelector(hasInitialTourEditorState(UUID));

  useEffect(() => {
    if (!isStateInitialised) {
      dispatch(setInitialTourEditorState({ uuid: UUID }));
    }
  }, [isStateInitialised, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearTourEditorState({ uuid: UUID }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (organizationId) {
      dispatch(setOrganizationId(String(organizationId)));
    }
  }, [organizationId]);

  useElectronListener<{ type: string }>(
    AppEventsEnum.APP_TO_RELATED_VIEW + argsFromProcess?.innerTabId,
    (msg) => {
      window.postMessage({ type: msg.type }, '*');
    },
    [argsFromProcess]
  );

  return (
    <div className="grow shrink basis-0 min-h-0">
      {!!organizationId && !!workspaceId && !!tourId && (
        <MemoryRouter initialEntries={[initialRoute]}>
          <RumRouteTracker />
          <Routes>
            <Route
              path="presentation/:organizationId/:workspaceId/:tourId"
              element={
                <TourPreviewPage
                  onPlayStep={(payload) =>
                    postMessage?.({
                      type: 'onStepChange',
                      payload,
                    })
                  }
                  uuid={UUID}
                  mimesisStepEngineUrl={mimesisStepEngineRelativeUrl}
                  fileServiceDynamicLink={settings.FILES_SERVICE_URL}
                  isDebugMode={false}
                />
              }
            />
          </Routes>
        </MemoryRouter>
      )}
    </div>
  );
};

export default TourView;
